export default __webpack_public_path__ + "static/media/users-icon.6077e29c.svg";